
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AcBottomNavigation',
  props: {
    fixed: {
      type: Boolean,
      default: false
    },
    sticky: {
      type: Boolean,
      default: false
    }
  }
})
